import { PlacementTestResult } from '@/common/types/placementTest';
import { formatTimeTaken } from '@/common/utils/datetime';
import { getWordById, getWordGraphemes } from '@/common/utils/scopeAndSequence';
import { TableCell, TableHead, TableRow } from '@shadcn/components/table';
import {
  CorrectChoice,
  GenericCell,
  IncorrectChoice,
  PartiallyCorrectChoice,
} from './CellStyles';
import GenericAttemptTable from './GenericAttemptTable';

interface PlacementTestAttemptTableProps {
  placementTestResult: PlacementTestResult;
}

export default function PlacementTestAttemptTable({
  placementTestResult,
}: PlacementTestAttemptTableProps) {
  return (
    <GenericAttemptTable
      renderHeader={() => (
        <TableRow className="hover:bg-white">
          <TableHead>Question</TableHead>
          <TableHead>Served Word</TableHead>
          <TableHead>Student Attempt</TableHead>
          <TableHead>Time Taken</TableHead>
        </TableRow>
      )}
      renderData={() =>
        placementTestResult.wordResponses.map(
          ({ correctWord, analysis, startedAt, endedAt }, index) => {
            const word = getWordById(correctWord);
            if (!word) return null;
            const wordGraphemes = getWordGraphemes(word);
            return (
              <TableRow key={index} className="hover:bg-white">
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    {wordGraphemes.map((p, i) => (
                      <GenericCell
                        className="bg-blue-100 text-blue-800"
                        key={i}
                      >
                        {p.spelling}
                      </GenericCell>
                    ))}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    {analysis.attemptGraphemes.map((grapheme, i) =>
                      analysis.attemptToCorrectDistances[i] === 0 ? (
                        <CorrectChoice key={i}>{grapheme}</CorrectChoice>
                      ) : analysis.attemptToCorrectDistances[i] <
                        wordGraphemes.length ? (
                        <PartiallyCorrectChoice key={i}>
                          {grapheme}
                        </PartiallyCorrectChoice>
                      ) : (
                        <IncorrectChoice key={i}>{grapheme}</IncorrectChoice>
                      ),
                    )}
                  </div>
                </TableCell>
                <TableCell>{formatTimeTaken(startedAt, endedAt)}</TableCell>
              </TableRow>
            );
          },
        )
      }
      isEmpty={placementTestResult.wordResponses.length === 0}
    />
  );
}
